import type { MouseEventHandler } from 'react';
import React from 'react';

import { Divider, Rate, Space, Typography } from '@sravni/react-design-system';

import styles from './rating-with-reviews.module.scss';

export const RatingWithReviews = ({
  rating,
  reviewCount,
  onClick,
}: {
  rating: number;
  reviewCount: number;
  onClick?: MouseEventHandler;
}) => (
  <div className="h-mt-16">
    {rating ? (
      <Space direction="horizontal" align="center" onClick={onClick}>
        {rating && (
          <>
            <Rate count={1} value={1} disabled className={styles.starIcon} size={16} />
            <Typography.Text size={12} className="h-color-D100">
              {String(rating.toFixed(1))}
            </Typography.Text>
          </>
        )}
        {reviewCount && (
          <div className={styles.reviewsBlock}>
            <Typography.Text size={12} className="h-color-D60 h-ml-4">
              ({reviewCount})
            </Typography.Text>
          </div>
        )}
        <Typography.Link className="h-ml-4">
          <Typography.Text size={12} strong>
            Читать отзывы
          </Typography.Text>
        </Typography.Link>
      </Space>
    ) : (
      <Typography.Text size={12} className="h-color-D30">
        Пока нет отзывов
      </Typography.Text>
    )}
    <Divider className="h-mt-16 h-mb-4" />
  </div>
);
